module.exports = __webpack_public_path__ + "img/Butterfly_00385.6b0dfd89.png";